import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { WorkspaceService } from '../services/workspace.service';
import { Auth } from '@angular/fire/auth';
import { firstValueFrom, from, switchMap } from 'rxjs';
import { UserService } from '../services/user.service';
import { AppService } from '../services/app.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(Auth);
  const app = inject(AppService);
  const userService = inject(UserService);
  const workspaceService = inject(WorkspaceService);

  var headers: { [name: string]: string | string[] } = {};

  if (app.clientId) headers['x-voxr-client-id'] = app.clientId;

  if (auth.currentUser) {
    return from(auth.currentUser!.getIdToken()).pipe(
      switchMap(idToken => {
        if (idToken) headers['Authorization'] = `Bearer ${idToken}`;
        if (userService.impersonated()) headers['x-voxr-impersonate'] = userService.impersonated()!;
        if (workspaceService.workspaceId && !req.headers.get('x-voxr-workspace')?.trim()) {
          headers['x-voxr-workspace'] = workspaceService.workspaceId;
        }
        const user = userService._user;
        if (user?.resellerId || app.brand()?.resellerId) headers['x-voxr-reseller'] = user?.resellerId || app.brand()?.resellerId!;
        else if (user?.resellerConfig?.isApproved && app.routeArea === 'reseller') // TODO: implement for reseller operators
          headers['x-voxr-reseller'] = user!._id!.toString();

        return next(req.clone({ setHeaders: headers }));
      })
    );
  }
  else {
    if (app.brand()?.resellerId) headers['x-voxr-reseller'] = app.brand()?.resellerId!;
    return next(req.clone({ setHeaders: headers }));
  }

};
